export default __webpack_public_path__ + "static/media/S.ef1e21b8.svg";